import axios from "axios"
import { useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { logout } from "../../../../Redux/Features/Auth/authSlice"
import { CONSUMERS } from "../../../../Utilities/APIs"

function ChangePassword() {

    const [oldPass, setOldPass] = useState('')
    const [newPass, setNewPass] = useState('')
    const [newPass2, setNewPass2] = useState('')

    const {consumer} = useSelector(state => state.auth)

    const dispatch = useDispatch()

    async function handleSubmit() {

        const config = {
            headers: {
                Authorization: `Bearer ${consumer.token}`
            }
        }

        if (newPass !== newPass2) {
            return console.log('Passwords do not match')
        }

        
        const passwordBody = {
            oldPassword: oldPass,
            newPassword: newPass
        }

        const passChange = await axios.patch(CONSUMERS + 'changeConsumerPassword', passwordBody, config)

        if (passChange) {
            setOldPass('')
            setNewPass('')
            setNewPass2('')
            dispatch(logout())
        }
    }

    return (
        <section className="auth_page page_padding">
            <div className="container">
                <div className="centered_form_wrapper">
                    <div className="form_wrapper">
                        <h3>Change Password</h3>
                        <form onSubmit={e => e.preventDefault()}>
                            <div className="input_group">
                                <label className="input_field_label caption bold">current password</label>
                                <input 
                                    type="password" 
                                    className="input_field body_text" 
                                    placeholder='Enter Password'
                                    value={oldPass}
                                    onChange={e => setOldPass(e.target.value)} 
                                />
                            </div>
                            <div className="input_group">
                                <label className="input_field_label caption bold">New password</label>
                                <input 
                                    type="password" 
                                    className="input_field body_text" 
                                    placeholder='Enter Password'
                                    value={newPass}
                                    onChange={e => setNewPass(e.target.value)} 
                                />
                            </div>
                            <div className="input_group">
                                <label className="input_field_label caption bold">confirm new password</label>
                                <input 
                                    type="password" 
                                    className="input_field body_text" 
                                    placeholder='Enter Password'
                                    value={newPass2}
                                    onChange={e => setNewPass2(e.target.value)} 
                                />
                            </div>
                            <button type='submit' className='btn_text btn_border' onClick={handleSubmit}>save new password</button>
                            <button type='submit' className='btn_text forgot_pass'>cancel</button>

                        </form>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default ChangePassword